
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import YouTube from "react-youtube";
import GeogebraDraw from "../../components/GeogebraDraw";
import VerticalSteps from "../../components/VerticalSteps";
import IfPaidUser from "../../components/IfPaidUser";
import "../../markdown-styles/styles.css";
import ReactPlayer from 'react-player'
import Stack from '@mui/material/Stack';
import Button from "@material-ui/core/Button";
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { CardActionArea } from '@mui/material';
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import Form from "../../components/NetlifyForm";
import Content from "../../components/Content";
import Container from "../../components/Layouts/Container";
import ContentTextBoxes from "../../components/Layouts/ContentTextBoxes";
export const ggbParameters = {
  // material_id: "",
  // width: "100%",
  // height: 950,
  borderColor: "#1E1e1E",
  enableShiftDragZoom: false,
  showToolBar: false
};

const layoutProps = {
  ggbParameters
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Gamma Squeeze`}</h1>
    <GeogebraDraw jsonUrl="https://storage.googleapis.com/chapters-ifm/testfolder/2022/COVERED_CALL/gamma_squeeze-2022-apr.json" ggbParameters={ggbParameters} appId="gamma_sqeeze" email="pavanmirla@gmail.com" data={[]} mdxType="GeogebraDraw" /> 
    <p><a parentName="p" {...{
        "href": "https://storage.googleapis.com/chapters-ifm/testfolder/2022/COVERED_CALL/quiz_board.ggb"
      }}>{`https://storage.googleapis.com/chapters-ifm/testfolder/2022/COVERED_CALL/quiz_board.ggb`}</a></p>
    <GeogebraDraw jsonUrl="https://storage.googleapis.com/chapters-ifm/testfolder/2022/COVERED_CALL/quiz_board.json" ggbParameters={ggbParameters} appId="gamma_sqeeze_2" email="pavanmirla@gmail.com" data={[]} mdxType="GeogebraDraw" /> 
    <Form mdxType="Form" />

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;